import { moneyDisplay } from "@icraftx/shared/v1";
import type { PartyRow } from "@/shared/api/parties";

/** Shared Contact glance fields — plan/45 peek + View more. */

export function contactRoleLabel(p: {
  isCustomer: boolean;
  isSupplier: boolean;
  partyKind?: string | null;
}): string {
  const kind = p.partyKind === "person" ? "Person" : null;
  const roles =
    p.isCustomer && p.isSupplier
      ? "Customer · Supplier"
      : p.isCustomer
        ? "Customer"
        : p.isSupplier
          ? "Supplier"
          : null;
  if (kind && roles) return `${kind} · ${roles}`;
  if (kind) return kind;
  return roles ?? "—";
}

export function contactGlanceStats(party: PartyRow): {
  roleLabel: string;
  code: string | null;
  primaryPhone: string | null;
  primaryEmail: string | null;
  outstandingAr: string | null;
  outstandingAp: string | null;
  peopleCount: number;
  notesPreview: string | null;
  deactivated: boolean;
} {
  const notes = party.notes?.trim() || null;
  return {
    roleLabel: contactRoleLabel(party),
    code: party.code,
    primaryPhone: party.primaryPhone ?? null,
    primaryEmail: party.primaryEmail ?? null,
    outstandingAr:
      party.isCustomer &&
      party.outstandingAr != null &&
      Number(party.outstandingAr) > 0
        ? moneyDisplay(party.outstandingAr)
        : null,
    outstandingAp:
      party.isSupplier &&
      party.outstandingAp != null &&
      Number(party.outstandingAp) > 0
        ? moneyDisplay(party.outstandingAp)
        : null,
    peopleCount: party.people?.length ?? 0,
    notesPreview: notes
      ? notes.length > 120
        ? `${notes.slice(0, 117)}…`
        : notes
      : null,
    deactivated: party.deactivatedAt != null,
  };
}
